import { newsApi } from './api';


export const CompanyService = newsApi.injectEndpoints({
    endpoints: (build) => ({
        getCompany: build.query({
            query: ({pagination}) => ({
                url: `companies${pagination && pagination}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Driver'],
        }),
        addCompany: build.mutation({
            query: (form) => ({
                url: `companies/store`,
                method: 'POST',
                body: form,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        editCompany: build.mutation({
            query: ({ id, newForm }) => ({
                url: `companies/update/${id}`,
                method: 'POST',
                body: newForm,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        removeCompany: build.mutation({
            query: (id) => ({
                url: `${''}/${id}`,
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        changeStatusCompany: build.mutation({
            query: ({ id, status }) => ({
                url: `companies/status/${id}/${status}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
    }),
    overrideExisting: false,
})

export const {
    useGetCompanyQuery,
    useAddCompanyMutation,
    useEditCompanyMutation,
    useRemoveCompanyMutation,
    useChangeStatusCompanyMutation,
} = CompanyService